/**
 * PrivateRoute - Protege rutas que requieren autenticación
 * Usa Firebase Authentication para verificar el estado de la sesión
 */

import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      // Verificar autenticación de Firebase + localStorage
      const hasUserId = !!localStorage.getItem("user_id");
      const hasFirebaseUser = !!firebaseUser;

      // Usuario autenticado si tiene sesión en Firebase Y user_id en localStorage
      // O si solo tiene user_id (legacy, usuarios que no han migrado a Firebase)
      setIsAuthenticated(hasFirebaseUser || hasUserId);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Mostrar loading mientras verificamos autenticación
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)",
        }}
      >
        <CircularProgress sx={{ color: "#6366f1", mb: 2 }} />
        <Typography sx={{ color: "rgba(255, 255, 255, 0.7)" }}>
          Verificando sesión...
        </Typography>
      </Box>
    );
  }

  // Si no está autenticado, redirigir a login guardando la ruta actual
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
